import React from "react";
import {
    Box,
    Container,
    SimpleGrid,
    VStack,
    HStack,
    Heading,
    Text,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";

import { DoodleSparkle } from "../../CustomUi/DoodleIcons";

const PublicFooter: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (sectionId: string) => {
        if (location.pathname === "/") {
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        } else {
            window.location.href = `/#${sectionId}`;
        }
    };

    const linkStyle = {
        fontSize: "sm" as const,
        opacity: 0.75,
        cursor: "pointer" as const,
        transition: "all 0.15s ease",
        _hover: { opacity: 1, color: "gold.300", transform: "translateX(2px)" },
    };

    return (
        <Box py={14} bg="brand.900" color="white" borderTop="3px solid" borderColor="gold.500">
            <Container maxW="7xl">
                <SimpleGrid columns={[1, 2, 4]} gap={10} mb={10}>
                    <VStack align="start" gap={4}>
                        <img
                            src="/logo.svg"
                            alt="Result"
                            style={{ height: "32px" }}
                        />
                        <Text fontSize="sm" opacity={0.7} lineHeight="1.6">
                            School management built for Nigerian and African schools. Simple results, instant fees.
                        </Text>
                        <HStack gap={1} className="font-handwriting" fontSize="md" color="gold.300">
                            <Text>Crafted with 💚 for great schools</Text>
                            <DoodleSparkle size={14} color="#FBBF24" />
                        </HStack>
                    </VStack>

                    <VStack align="start" gap={3}>
                        <Heading as="h5" fontSize="xs" letterSpacing="widest" textTransform="uppercase" opacity={0.5} mb={1}>
                            Product
                        </Heading>
                        <Text {...linkStyle} onClick={() => navigate("/features")}>Features</Text>
                        <Text {...linkStyle} onClick={() => navigate("/pricing")}>Pricing</Text>
                        <Text {...linkStyle} onClick={() => navigate("/demo")}>Interactive Demo</Text>
                        <Text {...linkStyle} onClick={() => navigate("/blog")}>Blog</Text>
                    </VStack>

                    <VStack align="start" gap={3}>
                        <Heading as="h5" fontSize="xs" letterSpacing="widest" textTransform="uppercase" opacity={0.5} mb={1}>
                            Company
                        </Heading>
                        <Text {...linkStyle} onClick={() => navigate("/about")}>About Us</Text>
                        <Text {...linkStyle} onClick={() => navigate("/affiliates")}>Affiliates Program</Text>
                        <Text {...linkStyle} onClick={() => navigate("/contact")}>Contact Support</Text>
                        <Text {...linkStyle} onClick={() => handleNavigation("faq")}>Help &amp; FAQ</Text>
                    </VStack>

                    <VStack align="start" gap={3}>
                        <Heading as="h5" fontSize="xs" letterSpacing="widest" textTransform="uppercase" opacity={0.5} mb={1}>
                            Legal
                        </Heading>
                        <Text {...linkStyle} onClick={() => navigate("/privacy")}>Privacy Policy</Text>
                        <Text {...linkStyle} onClick={() => navigate("/terms")}>Terms of Service</Text>
                    </VStack>
                </SimpleGrid>

                <Box pt={8} borderTop="1px" borderColor="whiteAlpha.200">
                    <HStack justify="space-between" flexWrap="wrap" gap={2}>
                        <Text fontSize="xs" opacity={0.5}>
                            © {new Date().getFullYear()} Numero Technology Limited. All rights reserved.
                        </Text>
                        <Text fontSize="xs" opacity={0.5}>
                            Result is a product of Numero Technology Limited
                        </Text>
                    </HStack>
                </Box>
            </Container>
        </Box>
    );
};

export default PublicFooter;
